import i18next, { t } from "i18next";
import React from "react";

const WeekPlanChart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsxlink="http://www.w3.org/1999/xlink"
      width="100%"
      viewBox="0 0 389 257"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.022"
          y1="0.98"
          x2="1"
          y2="0.978"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#c40606"></stop>
          <stop offset="0.477" stop-color="#fb0"></stop>
          <stop offset="1" stop-color="#419741"></stop>
        </linearGradient>
      </defs>
      <g id="_1" data-name="1" transform="translate(-20.5 -332)">
        <line
          id="Line_36"
          data-name="Line 36"
          y1="47"
          transform="translate(49 522)"
          fill="none"
          stroke="#989898"
          stroke-linecap="round"
          stroke-width="1"
        ></line>
        <line
          id="Line_38"
          data-name="Line 38"
          x2="388"
          transform="translate(21 569.5)"
          fill="none"
          stroke="#989898"
          stroke-linecap="round"
          stroke-width="1"
        ></line>
        <line
          id="Line_39"
          data-name="Line 39"
          x2="388"
          transform="translate(21 509.5)"
          fill="none"
          stroke="#dbdbdb"
          stroke-linecap="round"
          stroke-width="1"
        ></line>
        <line
          id="Line_40"
          data-name="Line 40"
          x2="388"
          transform="translate(21 449.5)"
          fill="none"
          stroke="#dbdbdb"
          stroke-linecap="round"
          stroke-width="1"
        ></line>
        <line
          id="Line_41"
          data-name="Line 41"
          x2="388"
          transform="translate(21 389.5)"
          fill="none"
          stroke="#dbdbdb"
          stroke-linecap="round"
          stroke-width="1"
        ></line>
        <line
          id="Line_37"
          data-name="Line 37"
          y1="222"
          transform="translate(381 347)"
          fill="none"
          stroke="#989898"
          stroke-linecap="round"
          stroke-width="1"
        ></line>
        <g id="Untitled" transform="translate(-883.944 -464.268)">
          <path
            id="curve"
            d="M937.213,997.463a4.992,4.992,0,0,1,.941-9.939c31.367,2.971,53.3-13.509,71.012-33.095,18.968-20.973,33.386-45.461,48.4-56.658,8.611-6.42,22.169-9.856,38.556-11.665,23.029-2.545,51.884-2.131,79.465-4.446,17.876-1.5,35.21-4.14,49.936-9.64,20.926-7.814,36.434-21.537,39.737-46.617a4.991,4.991,0,1,1,9.9,1.3c-6.294,47.8-50.325,60.843-98.736,64.9-27.487,2.3-56.248,1.883-79.2,4.42-14.265,1.575-26.187,4.157-33.682,9.746-14.626,10.907-28.486,34.918-46.963,55.35C996.837,982.945,972.158,1000.772,937.213,997.463Z"
            transform="translate(0 0)"
            fill="none"
            stroke="url(#linear-gradient)"
            stroke-width="10"
            stroke-dasharray="1000"
            stroke-dashoffset="1000"
          >
            <animate
              attributeName="stroke-dashoffset"
              from="1000"
              to="585"
              dur="1s"
              fill="freeze"
            ></animate>
          </path>
        </g>
        <g id="Group_2503" data-name="Group 2503">
          <g
            id="Ellipse_41"
            data-name="Ellipse 41"
            fill="#fff"
            stroke="#c40606"
            stroke-width="1"
            transform="translate(34 509)"
          >
            <circle cx="15" cy="15" r="15" stroke="none"></circle>
            <circle cx="15" cy="15" r="14.5" fill="none"></circle>
          </g>
          <circle
            id="Ellipse_42"
            data-name="Ellipse 42"
            cx="10"
            cy="10"
            r="10"
            fill="#c40606"
            transform="translate(39 514)"
          ></circle>
        </g>
        <g
          id="Group_2504"
          data-name="Group 2504"
          transform="translate(332 -175)"
        >
          <g
            id="Ellipse_41-2"
            data-name="Ellipse 41"
            transform="translate(34 507)"
            fill="#fff"
            stroke="#419741"
            stroke-width="1"
          >
            <circle cx="15" cy="15" r="15" stroke="none"></circle>
            <circle cx="15" cy="15" r="14.5" fill="none"></circle>
          </g>
          <circle
            id="Ellipse_42-2"
            data-name="Ellipse 42"
            cx="10"
            cy="10"
            r="10"
            transform="translate(39 512)"
            fill="#419741"
          ></circle>
        </g>
        <g
          id="Group_2488"
          data-name="Group 2488"
          transform="translate(-53.795 -109.561)"
        >
          {i18next.language === "fr" ? (
            <path
              id="Path_94"
              data-name="Path 94"
              d="M 658.043 291.114 h -10 a 3.4 3.4 0 0 1 -3.395 -3.4 V 274.661 a 3.4 3.4 0 0 1 3.395 -3.395 h 58.819 a 3.4 3.4 0 0 1 3.395 3.395 v 13.058 a 3.4 3.4 0 0 1 -3.395 3.4 h -31 l -7.91 7.91 Z"
              transform="translate(-566.158 312.537)"
              fill="#474747"
              fill-rule="evenodd"
            ></path>
          ) : (
            <path
              id="Path_94"
              data-name="Path 94"
              d="M661.043,291.114h-10a3.4,3.4,0,0,1-3.395-3.4V274.661a3.4,3.4,0,0,1,3.395-3.395h35.819a3.4,3.4,0,0,1,3.395,3.395v13.058a3.4,3.4,0,0,1-3.395,3.4h-10l-7.91,7.91Z"
              transform="translate(-566.158 312.537)"
              fill="#474747"
              fill-rule="evenodd"
            ></path>
          )}
          <text
            id="Now"
            transform="translate(103 597)"
            fill="#fff"
            font-size="10"
            font-family="OpenSans, Open Sans"
          >
            {i18next.language === "en" ? (
              <tspan x="-10" y="0">
                {t("career_plan_ready.now")}
              </tspan>
            ) : i18next.language === "fr" ? (
              <tspan x="-18" y="0">
                {t("career_plan_ready.now")}
              </tspan>
            ) : i18next.language === "de" ? (
              <tspan x="-10" y="0">
                {t("career_plan_ready.now")}
              </tspan>
            ) : i18next.language === "it" ? (
              <tspan x="-16" y="0">
                {t("career_plan_ready.now")}
              </tspan>
            ) : (
              <tspan x="-14" y="0">
                {t("career_plan_ready.now")}
              </tspan>
            )}
          </text>
        </g>
        <g
          id="Group_2505"
          data-name="Group 2505"
          transform="translate(244.326 -250.682)"
        >
          {i18next.language === "en" ? (
            <path
              id="Path_94-2"
              data-name="Path 94"
              d="M661.043,291.114h-2a3.4,3.4,0,0,1-3.395-3.4v-66.74a3.4,3.4,0,0,1,3.4-3.395h19.819a3.4,3.4,0,0,1,3.395,3.395v66.74a3.4,3.4,0,0,1-3.395,3.4h-2l-7.91,7.91Z"
              transform="translate(-182.35 1266.635) rotate(-90)"
              fill="#474747"
              fill-rule="evenodd"
            ></path>
          ) : i18next.language === "fr" ? (
            <path
              id="Path_94-2"
              data-name="Path 94"
              d="M 661.043 291.114 h -2 a 3.4 3.4 0 0 1 -3.395 -3.4 v -86.74 a 3.4 3.4 0 0 1 3.4 -3.395 h 19.819 a 3.4 3.4 0 0 1 3.395 3.395 v 87.74 a 3.4 3.4 0 0 1 -3.395 3.4 h -2 l -7.91 7.91 Z"
              transform="translate(-182.35 1266.635) rotate(-90)"
              fill="#474747"
              fill-rule="evenodd"
            ></path>
          ) : (
            <path
              id="Path_94-2"
              data-name="Path 94"
              d="M661.043,291.114h-2a3.4,3.4,0,0,1-3.395-3.4v-111.74a3.4,3.4,0,0,1,3.4-3.395h19.819a3.4,3.4,0,0,1,3.395,3.395v111.74a3.4,3.4,0,0,1-3.395,3.4h-2l-7.91,7.91Z"
              transform="translate(-182.35 1266.635) rotate(-90)"
              fill="#474747"
              fill-rule="evenodd"
            ></path>
          )}
          <text
            id="After_4_weeks"
            data-name="After 4 weeks"
            transform="translate(72.795 601.269)"
            fill="#fff"
            font-size="10"
            font-family="OpenSans, Open Sans"
          >
            {i18next.language === "en" ? (
              <tspan x="-31" y="0">
                {t("career_plan_ready.after_4_weeks")}
              </tspan>
            ) : i18next.language === "fr" ? (
              <tspan x="-50" y="0">
                {t("career_plan_ready.after_4_weeks")}
              </tspan>
            ) : i18next.language === "de" ? (
              <tspan x="-60" y="0">
                {t("career_plan_ready.after_4_weeks")}
              </tspan>
            ) : i18next.language === "it" ? (
              <tspan x="-65" y="0">
                {t("career_plan_ready.after_4_weeks")}
              </tspan>
            ) : i18next.language === "pt" ? (
              <tspan x="-60" y="0">
                {t("career_plan_ready.after_4_weeks")}
              </tspan>
            ) : (
              <tspan x="-75" y="0">
                {t("career_plan_ready.after_4_weeks")}
              </tspan>
            )}
          </text>
        </g>{" "}
        <text
          id="Week_1"
          data-name="Week 1"
          transform="translate(49 586)"
          fill="#989898"
          font-size="10"
          font-family="OpenSans, Open Sans"
        >
          <tspan x="-17" y="0">
            {t("career_plan_ready.week_labels.week_1")}
          </tspan>
        </text>
        <text
          id="Week_2"
          data-name="Week 2"
          transform="translate(160 586)"
          fill="#989898"
          font-size="10"
          font-family="OpenSans, Open Sans"
        >
          <tspan x="-17" y="0">
            {t("career_plan_ready.week_labels.week_2")}
          </tspan>
        </text>
        <text
          id="Week_3"
          data-name="Week 3"
          transform="translate(270 586)"
          fill="#989898"
          font-size="10"
          font-family="OpenSans, Open Sans"
        >
          <tspan x="-17" y="0">
            {t("career_plan_ready.week_labels.week_3")}
          </tspan>
        </text>
        <text
          id="Week_4"
          data-name="Week 4"
          transform="translate(381 586)"
          fill="#989898"
          font-size="10"
          font-family="OpenSans, Open Sans"
        >
          <tspan x="-17" y="0">
            {t("career_plan_ready.week_labels.week_4")}
          </tspan>
        </text>
      </g>
    </svg>
  );
};

export default WeekPlanChart;
